import React from 'react';
import { Button as MuiButton, ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledButton = styled(MuiButton)(({ theme }) => ({
  borderRadius: '25px',
  padding: '12px 32px',
  textTransform: 'none',
  fontSize: '1rem',
  fontWeight: 600,
  background: theme.palette.primary.main,
  '&:hover': {
    background: theme.palette.primary.dark,
  },
  '&.contained': {
    background: 'linear-gradient(45deg, #4169E1 30%, #6B8EF2 90%)',
    '&:hover': {
      background: 'linear-gradient(45deg, #2B4DB2 30%, #4169E1 90%)',
    },
  }
}));

export const Button: React.FC<ButtonProps> = (props) => {
  return <StyledButton {...props} />;
}; 